import { actionType } from './action';

export const InitialState = Object.freeze({
    profile: {}

});


const reducer = (preState = InitialState, action) => {
    const { type, payload } = action;

    switch (type) {       

        case actionType.SET_FUNDER_APPLICANT_PROFILE:          
            return {
                ...preState,
                profile: {
                    ...payload
                }
            };

        case actionType.RESET_STORE:
            return InitialState;

        default:
            return preState;
    }
}

export default reducer;